const state = {
    isCompoundScoreEnabled: false,
    compoundScore: -1,
    compoundScoreUnfiltered: -1,
    compoundText: '',

    parent_period_id: 0,
    period: '',

    surveyInfo: {
        num_finished: null,
        survey_name: {},
        time_period: {
            start: ""
        },
        dates: {
            start: "",
            yearStart: "",
            end: "",
            yearEnd: "",
        },
        survey_id: -1,
        respondentOriginCount: -1,
        responseRate: -1,
        respondentsExpected: -1,
    },

    filters: {},

    is_pdf: false,
};

const mutations = {
    setCompoundEnabled: (state, boolean) => {
        Vue.set(state, 'isCompoundScoreEnabled', boolean);
    },
    setCompoundName: (state, name) => {
        Vue.set(state, 'compoundScoreName', name);
    },
    setCompoundScore: (state, score) => {
        Vue.set(state, 'compoundScore', score);
    },
    setCompoundScoreUnfiltered: (state, score) => {
        Vue.set(state, 'compoundScoreUnfiltered', score);
    },
    setCompoundText: (state, compoundText) => {
        Vue.set(state, 'compoundText', compoundText);
    },

    setParentPeriodId: (state, parent_period_id) => {
        Vue.set(state, "parent_period_id", parent_period_id);
    },
    setPeriodString: (state, period) => {
        Vue.set(state, "period", period);
    },

    setSurveyInfo(state, obj) {
        Vue.set(state, 'surveyInfo', {...state.surveyInfo, ...obj});
    },
    setSurveyTemplateId(state, id) {
        Vue.set(state.surveyInfo, 'survey_id', id);
    },
    setSurveyDates(state, dates) {
        Vue.set(state.surveyInfo, 'dates', dates);
    },
    setRespondentOriginCount(state, count) {
        Vue.set(state.surveyInfo, 'respondentOriginCount', count);
    },
    setResponseRate(state, responseRate) {
        Vue.set(state.surveyInfo, 'responseRate', responseRate);
    },
    setRespondentsExpected(state, expected) {
        Vue.set(state.surveyInfo, 'respondentsExpected', expected);
    },
    setFilters: (state, filters) => {
        Vue.set(state, "filters", Object.assign({}, filters));
    },
    setIsPdfView: (state, boolean) => {
        Vue.set(state, "is_pdf", boolean);
    },
};

const getters = {
    getCompoundEnabled: (state) => state.isCompoundScoreEnabled,
    getCompoundScoreName: (state) => state.compoundScoreName,
    getCompoundScore: (state) => state.compoundScore,
    getCompoundScoreUnfiltered: (state) => state.compoundScoreUnfiltered,
    getCompoundText: (state) => state.compoundText,

    getParentPeriodId: (state) => state.parent_period_id,
    getPeriodString: (state) => state.period,
    getSurveyInfo: (state) => state.surveyInfo,

    getOrganizationName: (state) => state.surveyInfo.organization_name,
    getSurveyName: (state) => state.surveyInfo.survey_name,
    getSurveyTemplateId: (state) => state.surveyInfo.survey_id,
    getSurveyStart: (state) => state.surveyInfo.time_period.start,
    getSurveyFormattedDates: (state) => state.surveyInfo.dates,

    getRespondents: (state) => state.surveyInfo.num_finished,
    getRespondentOriginCount: (state) => state.surveyInfo.respondentOriginCount,
    getRespondentsExpected: (state) => state.surveyInfo.respondentsExpected,
    getOrganizations: (state) => state.surveyInfo.organizations,
    getResponseRate: (state) => state.surveyInfo.responseRate,
    getFilters: (state) => state.filters,
    getIsPdfView: (state) => state.is_pdf,
};

export default {
    state,
    mutations,
    getters
}
